(() => {
  'use strict';
  const linkPolicyContacts = () => {
    const root = document.querySelector('.shopify-policy__body');
    if (!root) return;
    root.querySelectorAll('a:not([href])').forEach(link => {
      const text = link.textContent.trim();
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(text)) link.href = 'mailto:' + text;
      if (text === 'https://speedtin.com/pages/' || text === 'contact-us') link.href = (window.Shopify?.routes?.root || '/') + 'pages/contact-us';
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const candidates = [];
    while (walker.nextNode()) {
      const text = walker.currentNode;
      if (!text.parentElement.closest('a,script,style,textarea') && /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(text.textContent)) candidates.push(text);
    }
    candidates.forEach(node => {
      const text = node.textContent;
      const regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
      const fragment = document.createDocumentFragment();
      let end = 0;
      for (const match of text.matchAll(regex)) {
        fragment.append(document.createTextNode(text.slice(end, match.index)));
        const link = document.createElement('a');
        link.textContent = match[0]; link.href = 'mailto:' + match[0];
        fragment.append(link); end = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(text.slice(end))); node.replaceWith(fragment);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkPolicyContacts); else linkPolicyContacts();
})();
